import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import worldofpain from './worldofpain.gif'
import Chip from '@material-ui/core/Chip';
import FaceIcon from '@material-ui/icons/Face';
import DoneIcon from '@material-ui/icons/Done';

import firebase from './fire.js';
const styles = {
  card: {
 
    marginTop: '2rem',    
    marginBottom: '2rem',

    margin: '0 auto'    
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    marginBottom: 16,
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
  buttons: {
    margin: '0 auto',
    width: '50%',
    display: 'block !important'
  },
  textField: {
   
    width: '80%'
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'center'
  },
};

class NewIdeaForm extends Component {
    state = {
        name: "",
        description: "",
        alreadySubmitted: false
    }



    handleChange = name => event => {
        this.setState({
          [name]: event.target.value,
        });

    };

    handlePostButtonClick = () => {
        this.writeUserData("blubber","dww","fick","www.google.de")

    }
    writeUserData = (userId, name, email, imageUrl) => {
        firebase.database().ref('posts/').push({
          name: this.state.name,
          description: this.state.description,
          votes:0,
          created_at: Date.now().toString(),
          data: [
            {
              value: 1,
              label: 'yes',
              color: "green"
            },
            {
              value: 1,
              label: 'No',
              color: "red"
            },
          ]
        });
      this.setState({
        description: "",
        name: "",
        alreadySubmitted: true
      });

      }

    render(){

     const can_be_posted = ( this.state.name.length > 10 && this.state.description.length > 10);;



  const { classes } = this.props;
  const bull = <span className={classes.bullet}>•</span>;
  let width = window.screen.availWidth;
  let cardWidth=''
  if (width > 720) {
    cardWidth='50%';
  } else {
    cardWidth="95%"
  }

  return (
    <div>
      <Card className={classes.card} style={{maxWidth:cardWidth}}>
        <CardContent>
        <h1>          If you found a problem or something interesting to solve - tell the world about it here!
        </h1>
        {/*<img src={worldofpain} className={classes.img_button}  style={{width:'250px'}} alt="nono" />*/}


      
          <form className={classes.container} noValidate autoComplete="off">
        <TextField
          id="name"
          label="Short title for the problem"
          className={classes.textField}
          value={this.state.name}
          onChange={this.handleChange('name')}
          margin="normal"
        />

          <TextField
          id="textarea"
          label="Problem description"
          placeholder="Details in here"
          multiline
          rows="4"
          className={classes.textField}
          onChange={this.handleChange('description')}
          value={this.state.description}
          margin="normal"
        />
        
        
        </form>
       
        </CardContent>
        <CardActions className={classes.buttons}>
          { this.state.alreadySubmitted ?   <Chip
              icon={<DoneIcon />}
              label="Thanks for the submission!"
              style={{    margin: "1rem" }}
              color="secondary"
            /> :
          <Button disabled = {!can_be_posted} variant="outlined" color="secondary" onClick={()=> this.handlePostButtonClick()}>
   Submit now!

    </Button>}

        </CardActions>

      </Card>
    </div>
  );
}
}

NewIdeaForm.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(NewIdeaForm);


// WEBPACK FOOTER //
// ./src/NewIdeaForm.js